import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';
import { message } from 'antd';

var UpdateCustomNavigationAction = function () {

}


UpdateCustomNavigationAction.prototype = {

    updateCustomNav: function (data) {

        restClient.updateCustomNav(data, function (error, response) {
            if (error) {
                message.error(error.data.message)
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error
                    });
                }
                else {
                    AppDispatcher.dispatch({
                        actionType: Constant.UPDATE_CUSTOM_NAV,
                        data: error
                    });
                }
            } else {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_CUSTOM_NAV,
                    data: response
                });
            }
        })
    }
}

export default new UpdateCustomNavigationAction();